export const catalogItemViewReducerPath = 'catalogItemView';
